import {gsap} from "gsap";
import {tweens_arrays_apparition as tween_big_title} from '../../../miscellaneous/bigTitle'
import {init_home_slider, timeline as timeline_slider} from '../../../home/slider'

const homeAnimationOnce = (container) => {
    console.log("homeAnimationOnce");
    timeline_slider.pause();
    init_home_slider();

    const section_w1 = $("#h-scroll-wrapper section.w1")

    gsap.set(section_w1, {autoAlpha:0})
    const tl = gsap.timeline({
        delay:0,
        defaults : {
            duration: 1,
            ease: "power1.out",
        }
    });
    timeline_slider.resume();
    tl
        //.set(container, {autoAlpha:0})
        .to('#site-preloader img', {autoAlpha: 1})
        .to('#site-preloader', {autoAlpha: 0, ease: "power1.in"}, '+=1')
        .add(tween_big_title, '-=0.5')
        .to(section_w1, {autoAlpha:1}, '-=0.5')
        .add(timeline_slider, '-=0.5');
        //.to(container, {autoAlpha: 1, ease: "power1.in", duration:1.5}, '-=0.5');
    // tl.timeScale(5);
    return tl;
}

export default homeAnimationOnce;